import { Box, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { modalColors } from '../../../DiscussionsModal/styled';

export const MessageWrapper = styled(Box)({});

export const SenderBox = styled(Box)<{ isOwn?: boolean }>(({ isOwn }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '4px',
    justifyContent: isOwn ? 'flex-end' : 'flex-start'
}));

export const SenderName = styled(Typography)({
    color: modalColors.mainGold,
    fontSize: '13px',
    fontWeight: 500
});

export const MessageContainer = styled(Box)<{ isOwn?: boolean }>(
    ({ isOwn }) => ({
        display: 'flex',
        justifyContent: isOwn ? 'flex-end' : 'flex-start',
        alignItems: 'flex-end',
        gap: '8px',
        position: 'relative'
    })
);

export const MessageContentWrapper = styled(Box)({
    maxWidth: '50%',
    position: 'relative'
});

export const MessageBubble = styled(Box)<{ isOwn?: boolean }>(({ isOwn }) => ({
    backgroundColor: '#2a2a2a',
    color: modalColors.white,
    padding: '12px',
    borderTopLeftRadius: isOwn ? '8px' : '0px',
    borderTopRightRadius: isOwn ? '0px' : '8px',
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
    wordBreak: 'break-word'
}));

export const ReplyBox = styled(Box)({
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    borderRadius: '8px',
    padding: '8px',
    marginBottom: '12px',
    opacity: 0.8
});

export const ReplyAuthor = styled(Typography)({
    color: modalColors.mainGold,
    fontSize: '12px',
    fontWeight: 500,
    display: 'block',
    marginBottom: '4px'
});

export const ReplyContent = styled(Typography)({
    fontSize: '13px',
    color: modalColors.white,
    lineHeight: 1.3,
    opacity: 0.9,
    whiteSpace: 'pre-wrap'
});

export const DeletedMessageText = styled(Typography)({
    fontSize: '13px',
    fontStyle: 'italic',
    color: '#888',
    marginBottom: '4px'
});

export const MessageContent = styled(Typography)({
    fontSize: '15px',
    lineHeight: 1.4,
    marginBottom: '4px',
    whiteSpace: 'pre-wrap'
});

export const MessageMetaBox = styled(Box)<{ isOwn?: boolean }>(({ isOwn }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    justifyContent: isOwn ? 'flex-end' : 'flex-start',
    marginTop: '8px'
}));

export const MessageTimestamp = styled(Typography)({
    color: '#666',
    fontSize: '11px'
});

export const ReactionsBox = styled(Box)<{ isOwn?: boolean }>(({ isOwn }) => ({
    display: 'flex',
    gap: '4px',
    marginTop: '4px',
    justifyContent: isOwn ? 'flex-end' : 'flex-start'
}));

export const ReactionChip = styled(Box)<{ isActive?: boolean }>(
    ({ isActive }) => ({
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        backgroundColor: isActive
            ? 'rgba(255, 167, 38, 0.2)'
            : 'rgba(255, 255, 255, 0.1)',
        borderRadius: '12px',
        padding: '2px 8px',
        cursor: 'pointer',
        border: isActive
            ? '1px solid rgba(255, 167, 38, 0.5)'
            : '1px solid transparent',
        '&:hover': {
            backgroundColor: isActive
                ? 'rgba(255, 167, 38, 0.3)'
                : 'rgba(255, 255, 255, 0.15)'
        }
    })
);

export const ReactionEmoji = styled(Typography)({
    fontSize: '12px'
});

export const ReactionCount = styled(Typography)({
    fontSize: '11px',
    color: modalColors.white,
    fontWeight: 500
});

export const MessageActions = styled(Box)<{ isOwn?: boolean }>(({ isOwn }) => ({
    position: 'absolute',
    top: 0,
    right: isOwn ? 0 : 'auto',
    left: isOwn ? 'auto' : 0,
    display: 'flex',
    gap: '8px',
    backgroundColor: modalColors.black5,
    padding: '4px 6px',
    borderRadius: '16px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.25)',
    opacity: 0.75,
    transition: 'opacity 150ms ease-in-out',
    transform: 'translateY(-50%)',
    alignItems: 'center',
    zIndex: 10
}));

export const ReactionButton = styled(IconButton)({
    width: '28px',
    height: '28px',
    fontSize: '14px',
    color: modalColors.white,
    '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)'
    }
});

export const ReactionPickerWrapper = styled(Box)({
    position: 'relative',
    display: 'inline-flex'
});

export const ReactionPickerPopover = styled(Box)<{ isOwn?: boolean }>(
    ({ isOwn }) => ({
        position: 'absolute',
        top: '100%',
        marginTop: '8px',
        right: isOwn ? 0 : 'auto',
        left: isOwn ? 'auto' : 0,
        zIndex: 1100
    })
);

export const MessageTextLink = styled('a')({
    color: modalColors.mainGold,
    textDecoration: 'none',
    fontWeight: 500,
    transition: 'color 150ms ease-in-out, opacity 150ms ease-in-out',
    '&:hover': {
        color: modalColors.mainGold,
        opacity: 0.8,
        textDecoration: 'underline'
    },
    '&:visited': {
        color: modalColors.gold
    }
});

export const MessageAttachmentsGrid = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '6px',
    marginTop: '8px'
});

export const MessageAttachmentItem = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    padding: '4px 10px',
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
    borderRadius: '10px',
    fontSize: '12px',
    gap: '6px',
    color: modalColors.mainGold,
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.14)'
    }
});
